/**
 * Modal de Desbloqueio de Confiança específico para integração Hubsoft.
 * Solicita qtd_dias (obrigatório) e envia junto com id_cliente_servico.
 */
import { VStack, Button } from '@chakra-ui/react';
import { useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { Input } from '@/components/atoms/Input';

const schema = z.object({
  qtd_dias: z.coerce.number().min(1, 'Informe a quantidade de dias (mínimo 1)'),
});

type FormData = z.infer<typeof schema>;

interface DesbloqueioConfiancaHubsoftModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: FormData) => Promise<void>;
  isSubmitting: boolean;
  colors: { primaryColor: string };
}

export function DesbloqueioConfiancaHubsoftModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
  colors,
}: DesbloqueioConfiancaHubsoftModalProps) {
  const form = useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: { qtd_dias: 1 },
  });

  useEffect(() => {
    if (isOpen) form.reset({ qtd_dias: 1 });
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Desbloqueio de Confiança</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <ModalBody>
            <VStack spacing={4}>
              <Input
                control={form.control}
                name="qtd_dias"
                label="Quantidade de dias"
                type="number"
                min={1}
                placeholder="Informe a quantidade de dias"
              />
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              variant="ghost"
              backgroundColor="transparent"
              color={colors.primaryColor}
              onClick={onClose}
              marginRight={2}
            >
              Cancelar
            </Button>
            <Button type="submit" isLoading={isSubmitting}>
              Confirmar
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
